import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HrService } from '../../../services/human-resources/hr.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUserPlus, faSave, faTimes, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-add-hr-manager',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FontAwesomeModule
  ],
  templateUrl: './add-hr-manager.component.html',
  styleUrls: ['./add-hr-manager.component.scss']
})
export class AddHrManagerComponent implements OnInit {
  // FontAwesome icons
  faUserPlus = faUserPlus;
  faSave = faSave;
  faTimes = faTimes;
  faInfoCircle = faInfoCircle;
  
  hrManagerForm: FormGroup;
  isSubmitting = false;
  errorMessage = '';
  successMessage = '';
  companyId: number | null = null;
  
  constructor(
    private fb: FormBuilder,
    private hrService: HrService
  ) {
    // Get company ID from localStorage
    const companyIdStr = localStorage.getItem('companyId');
    this.companyId = companyIdStr ? parseInt(companyIdStr, 10) : null;
    
    this.hrManagerForm = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', Validators.required]
    }, { 
      validators: this.passwordMatchValidator 
    });
  }

  ngOnInit(): void {
  }

  /**
   * Custom validator to check if passwords match
   */
  passwordMatchValidator(form: FormGroup) {
    const password = form.get('password')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    
    return password === confirmPassword ? null : { passwordMismatch: true };
  }

  /**
   * Submit the form to create an HR manager
   */
  onSubmit(): void {
    if (this.hrManagerForm.invalid) {
      // Mark all fields as touched to trigger validation messages
      Object.keys(this.hrManagerForm.controls).forEach(key => {
        this.hrManagerForm.get(key)?.markAsTouched();
      });
      return;
    }
    
    if (!this.companyId) {
      this.errorMessage = 'Could not determine your company ID. Please contact the system administrator.';
      return;
    }
    
    this.isSubmitting = true;
    this.errorMessage = '';
    this.successMessage = '';
    
    const formData = this.hrManagerForm.value;
    
    // Remove confirmPassword before sending to API and add the company_id
    const { confirmPassword, ...userDataBase } = formData;
    const userData = {
      ...userDataBase,
      company_id: this.companyId
    };
    
    this.hrService.addHrManager(userData).subscribe({
      next: (response) => {
        this.isSubmitting = false;
        this.successMessage = `HR Manager ${response.username} successfully created!`;
        this.hrManagerForm.reset();
      },
      error: (error) => {
        this.isSubmitting = false;
        this.errorMessage = error.error?.message || 'An error occurred while creating the HR manager.';
      }
    });
  }
} 